import API from './API';

// -----------------------------------------------------------------------------
//  Capacità driver per provincia.
//
//  I driver sono a chiamata: coprire una provincia non vuol dire essere
//  disponibili. Simba indica quanti driver e jolly garantisce
//  CONTEMPORANEAMENTE in una provincia, e il planner non vende orari oltre
//  (le corse contano anche senza driver assegnato, e anche gli spostamenti
//  interni che partono dalla provincia). NULL = nessun limite.
//
//  Dato interno di Simba: solo i ruoli globali, via /province-capacity. Le
//  GET /province e /region non lo mostrano.
// -----------------------------------------------------------------------------

export default {
  // Tutte le province con la loro capacità: [{ id, name, sigla, driver_capacity, jolly_capacity }].
  getCapacities() {
    return API.get('/province-capacity').then((r) => r.data ?? []);
  },

  // Scrive solo i due numeri; null toglie il limite.
  setCapacity(provinceId, { driver_capacity, jolly_capacity }) {
    return API.patch(`/province-capacity/${provinceId}`, { driver_capacity, jolly_capacity }).then((r) => r.data);
  },

  // Driver operativi per provincia, per dare un riferimento accanto ai numeri:
  // Map provinceId → { drivers, jolly }. ⚠️ Sui driver `is_alive = false`
  // vuol dire operativo.
  getOperativeDriversByProvince() {
    return API.get('/driver', {
      params: {
        join: ['provinces'],
        s: JSON.stringify({ is_alive: { $eq: false }, is_deleted: { $eq: false } }),
        limit: 1000,
      },
    }).then((r) => {
      const byProvince = new Map();
      for (const d of r.data?.data ?? r.data ?? []) {
        for (const p of d.provinces || []) {
          const counts = byProvince.get(p.id) || { drivers: 0, jolly: 0 };
          if (d.is_jolly) counts.jolly += 1;
          else counts.drivers += 1;
          byProvince.set(p.id, counts);
        }
      }
      return byProvince;
    });
  },
};
